<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">

            <div class="row" style="margin-top: 50px" v-if="cliente">

                <ol class="breadcrumb">
                    <li>
                        <a href="#/">
                            <i class="fa fa-home" aria-hidden="true"></i> INICIAL
                        </a>
                    </li>
                    <li>
                        <a href="#/clientes">
                            <i class="fa fa-id-card-o" aria-hidden="true"></i> CLIENTES
                        </a>
                    </li>
                    <li class="active">
                        LISTAGEM DOS CONTRATOS DE {{cliente.nome}}
                    </li>
                </ol>

                <div class="col-md-3">
                    <menu-cliente :cliente="cliente" ></menu-cliente>
                </div>
                <div class="col-md-9" >

                    <form class="form-horizontal">

                        <div class="panel panel-info" v-if="user">
                            <!-- Default panel contents -->
                            <div class="panel-heading">
                                <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                            </div>
                            <div class="panel-body">

                                <div class="form-group">

                                    <div class="col-sm-12">
                                        <label class="control-label">NOME DO CLIENTE</label>
                                        <input disabled type="text" v-model="cliente.nome"
                                               class="form-control" title="nome">
                                    </div>

                                </div>
                            </div>
                        </div>

                    </form>

                    <div class="panel panel-info">
                        <!-- Default panel contents -->
                        <div class="panel-heading">
                            <i class="fa fa-info-circle" aria-hidden="true"></i> CONTRATOS
                        </div>
                        <div class="panel-body">
                            <list-contratos
                                    :cliente_id="cliente._id"></list-contratos>
                        </div>
                    </div>




                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MenuCliente from "../../../menus/clientes.vue";
import { Cliente } from "../../../class/index";
import { ListContratos } from "../../../components/exports";

export default {
    components: {
        MenuCliente,
        ListContratos
    },
    data() {
        return {
            cliente: null,
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.params.id) {
            this.loadCliente(this.$route.params.id);
        }
    },
    methods: {
        loadCliente(id) {
            Cliente.byID(id)
                .then(row => {
                    this.tipo = row.tipo_cliente;
                    this.cliente = row;
                })
                .catch(err => console.error(err));
        }
    }
};
</script>
